module.exports = __webpack_public_path__ + "img/5人教练.df7d7452.png";